import { ComponentType } from 'react';
import { CIBaseOnboarding } from '@frontend/call-intel-onboarding';

/**
 * Global onboarding lifecycle registry.
 *
 * Each component in this registry is mounted once by the app shell.
 * These components do not render user-facing UI directly. Instead, they are
 * responsible for registering/unregistering their onboarding flow with the
 * shared product-onboarding store.
 *
 * Add a component here when a product area needs a global onboarding flow that should be available across the app.
 *
 * Guidelines for components added here:
 * - Keep them renderless when possible.
 * - Perform eligibility checks before registering a flow.
 * - Register the flow globally only when eligible.
 *
 * Example:
 * CIBaseOnboarding registers the Call Intelligence Base onboarding checklist globally.
 */
export const onboardingFlows: ComponentType[] = [CIBaseOnboarding];
